export const searchEmptableApi={
    heading:[
       
        {
            head:"ID"
        },
        {
            head:"Name"
        },
        {
            head:"Designation"
        },
        {
            head:"Email"
        }
    ],
    data:[
        {
            empHeaderId: 3,
            id: "1803120932",
            name: "MD DILU",
            designation: "ELECTRICIAN",
            email: "abc@gmail.com"
          },
          {
            empHeaderId: 3,
            id: "1803120932",
            name: "MD DILU",
            designation: "ELECTRICIAN",
            email: "abc@gmail.com"
          },
          {
            empHeaderId: 3,
            id: "1803120932",
            name: "MD DILU",
            designation: "ELECTRICIAN",
            email: "abc@gmail.com"
          },
          {
            empHeaderId: 3,
            id: "1803120932",
            name: "MD DILU",
            designation: "ELECTRICIAN",
            email: "abc@gmail.com"
          },
    ]
}

export const searchtableApi={
    heading:[
        {
            head:"Header ID"
        },
        {
            head:"ID"
        },
        {
            head:"Name"
        },
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Status"
        }
    ],
    data:[
        {
            headerid:14747,
            id:206102749,
            name:"Israt Nusrat",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
        {
            headerid:14747,
            id:206102749,
            name:"Israt Jahan",
            class: "Class 7",
            section:"Ruby-1",
            status:"Active"
        },
    ]
}

export const billtickApi={
    school:{
        allrcvtype:{
            stationary:{
                value:true,
                data:
                    {
                        sl:112,
                        rcvtype:"Stationary Fee",
                        billamount:16500,
                        actualamount:16500,
                        discount:0.00,
                        vat:0.00,
                        total:16500,
                        period:"OCT-23",
                        note:"Lorem Ipsum dolor sit amet"
                    }
                
            },
            idcard:{
                value:true,
                data:
                    {
                        sl:114,
                        rcvtype:"id card Fee",
                        billamount:500,
                        actualamount:500,
                        discount:50.00,
                        vat:0.00,
                        total:450,
                        period:"OCT-23",
                        note:"Lorem Ipsum dolor sit amet"

                    }
                
            },
            admissionfee:{
                value:true,
                data:
                    {
                        sl:115,
                        rcvtype:"id card Fee",
                        billamount:15000,
                        actualamount:15000,
                        discount:50.00,
                        vat:0.00,
                        total:15000,
                        period:"OCT-23",
                        note:"Lorem Ipsum dolor sit amet"

                    }
                
            },
            tuitionfee:{
                value:true,
                data:
                    {
                        sl:117,
                        rcvtype:"id card Fee",
                        billamount:15000,
                        actualamount:15000,
                        discount:50.00,
                        vat:0.00,
                        total:15000,
                        period:"OCT-23",
                        note:"Lorem Ipsum dolor sit amet"

                    }
                
            },
            diary:{
                value:false
            }
        }
    }
}

export const billCollectionApi= {
    heading:[
        {
            head:"SL"
        },
        {
            head:"receive Type"
        },
        {
            head:"Bill Amount"
        },
        {
            head:"Actual Amount"
        },
        {
            head:"Discount"
        },
        {
            head:"Vat"
        },
        {
            head:"Total"
        },
        {
            head:"Period"
        },
        {
            head:"Note"
        },
    ],
    data:[
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
        {
            sl:112,
            rcvtype:"Tuition Fee",
            billamount:16500,
            actualamount:16500,
            discount:0.00,
            vat:0.00,
            total:16500,
            period:"OCT-23",
            note:"Lorem Ipsum dolor sit amet"
        },
    ]
}

export const billInfoHistoryApi = {
    heading:[
        {
            head:"RcvType Name"
        },
        {
            head:"Class Name"
        },
        {
            head:"Bill Amount"
        },
        {
            head:"Vat"
        },
        {
            head:"Max Discount"
        },
        {
            head:"Attribute1"
        },
        {
            head:"Last Update Date"
        },
        {
            head:"Last Update By"
        },
        {
            head:"Creation Date"
        },
        {
            head:"Created By"
        },
        
        {
            head:"Action"
        },
        
    ],
    data:[
        {
            rcvtypename:"",
        },
        {
            rcvtypename:"",
        },
        {
            rcvtypename:"",
        },
    ]
}

export const prevCollectionhistoryApi = {
    heading:[
        {
            head:"Bill Number"
        },
        {
            head:"Date"
        },
        {
            head:"RCV Type"
        },
        {
            head:"Month"
        },
        {
            head:"Amount"
        }
    ],
    data:[
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
        {
            billnumber:22100000374,
            date:"15-Oct-22",
            rcvtype:"Tuition Fee",
            month:"Jul-23",
            amount:"5490.00"
        },
       
    ]
}